module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/fraternity-1-large-8b297baf9b45a75146274f69f242d767.jpg";